import { render, staticRenderFns } from "./my-downloads.vue?vue&type=template&id=722f6dd5&"
import script from "./my-downloads.vue?vue&type=script&lang=js&"
export * from "./my-downloads.vue?vue&type=script&lang=js&"
import style0 from "./my-downloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports